import { all, call, take } from 'redux-saga/effects';

import { gaEvent } from 'lib/analytics';
import {
  WIDGET_LOAD,
  WIDGET_UPDATE_BACKEND,
  WIDGET_UPDATE_FAIL,
  WIDGET_UPDATE_START,
  WIDGET_UPDATE_SUCCESS,
  WIDGET_UPDATE_VALUE,
} from '../actions';
import { urlJoin } from '../../utils';

const backendUpdate = (action) => {
  const { id, name, value, callback, sourceUrl = './' } = action;
  const dispatch = window.store.dispatch;

  popsss
    .postJSON(urlJoin(sourceUrl, 'update'), {
      id,
      name,
      value: JSON.stringify(value),
    })
    .done((result) => {
      if (result.error) {
        dispatch({
          type: WIDGET_UPDATE_FAIL,
          name,
          errorMessage: result.error,
        });
        if (callback) {
          callback({ success: false });
        }
      } else {
        dispatch({
          type: WIDGET_UPDATE_SUCCESS,
          name,
          value: result.value,
        });
        if (callback) {
          callback({ success: true });
        }
        // Load dependent widgets data if supplied
        if (result.widgets) {
          dispatch({
            type: WIDGET_LOAD,
            widgets: result.widgets,
          });
        }
        gaEvent('widget', 'update', name);
      }
    })
    .fail(() => dispatch({ type: WIDGET_UPDATE_FAIL, name }));
};

const updateWidgetState = (action) => {
  /* Updates the state of the widget so the UI changes when the user makes a change. */
  const { name, value, immediateUpdate, withSaving } = action;
  const dispatch = window.store.dispatch;

  if (immediateUpdate) {
    dispatch({ type: WIDGET_UPDATE_VALUE, name, value });
  } else if (withSaving) {
    dispatch({ type: WIDGET_UPDATE_START, name });
  }
};

function* updateValue() {
  /* This saga makes sure all widget updates are run, but only one at a time. Actions received when one is running (inFlight) are stored in nextActions. */
  const nextActions = [];
  let nextAction;
  let inFlight = false;
  let action = yield take(WIDGET_UPDATE_BACKEND);
  inFlight = true;
  yield call(updateWidgetState, action);
  yield call(backendUpdate, action);
  while (true) {
    if (inFlight) {
      nextAction = yield take([
        WIDGET_UPDATE_FAIL,
        WIDGET_UPDATE_SUCCESS,
        WIDGET_UPDATE_BACKEND,
      ]);
      if (nextAction.type == WIDGET_UPDATE_BACKEND) {
        yield call(updateWidgetState, nextAction);
        nextActions.push(nextAction);
      } else {
        action = nextActions.shift();
        if (action) {
          yield call(backendUpdate, action);
        } else {
          inFlight = false;
        }
      }
    } else {
      action = yield take(WIDGET_UPDATE_BACKEND);
      inFlight = true;
      yield call(updateWidgetState, action);
      yield call(backendUpdate, action);
    }
  }
}
export function* widgetSaga() {
  yield all([updateValue()]);
}
